module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/carrot-2480a401caf79129ac2cb52d00ef6fd4.svg";